export default "__VITE_ASSET__BPcpB4xl__"